export const CLEANUP_CHECKOUT_STATE = 'cleanup-checkout-state';
const cleanupCheckoutState = () => ({ type: CLEANUP_CHECKOUT_STATE });
export default cleanupCheckoutState;
